import { useState } from "react";
// import Input from "@mui/material/Input";
import "../../css/fileInput.css";
import upload from "../../static/upload.png";
import view from "../../static/view.png";
//
export const InputFile = ({ label, id, className, error, ...props }) => {
  //
  const [fileName, setFileName] = useState("No file chosen");
  //
  //
  const styles = {
    fileInput: {
      display: "None",
    },
  };

  // Handle file change
  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setFileName(e.target.files[0].name);
    } else {
      setFileName("No file chosen");
    }
  };
  return (
    <>
      <div className={`custom-file-label  ${className}`} key={id}>
        <label htmlFor={id}>{label}</label>
       
        <div className="flex ml-auto">
          <label htmlFor="" style={{ cursor: "pointer" }}>
            <img src={view} alt="" className="p-1" />
          </label>
          <label class="block" for="fileInput">
            <img
              src={upload}
              alt=""
              className="p-1"
              style={{ cursor: "pointer" }}
            />
          </label>
        </div>

        <input
          type="file"
          name=""
          id="fileInput"
          onChange={handleFileChange}
          style={styles.fileInput}
        />
        {/* // Display None */}
      </div>
    </>
  );
};
